"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M1 0h4a1 1 0 01.775 1.632L3.08 5H5a1 1 0 010 2H1a1 1 0 01-.771-1.636L2.919 2H1a1 1 0 110-2zm8.585 12.573l-2.98 2.98a1.526 1.526 0 01-2.158-2.158l2.98-2.98a4.502 4.502 0 016.013-5.977l-3 3.001a1.5 1.5 0 002.12 2.122l3.002-3.001a4.502 4.502 0 01-5.977 6.013z"];
//# sourceMappingURL=wrench-snooze.js.map